export enum NecessidadeProteseEnum {
  NAO_AVALIADO = 'NAO_AVALIADO',
  NAO = 'NAO',
  SIM = 'SIM',
}
